import React, { useEffect, useState } from 'react'
import { Spin } from 'antd'
import { connect } from 'react-redux'
import { get } from 'lodash'
import * as Sentry from '@sentry/browser'
import { roleuser } from '@edulastic/constants'
import notfification from '@edulastic/common/src/components/Notification'
import { getUser } from '../../author/src/selectors/user'
import { fetchAssignmentsByTestIdAction } from '../ducks'
import {
  fetchAssignmentsByTestAction,
  getAllAssignmentsSelector,
} from '../../publicTest/ducks'
import {
  startAssignmentAction,
  resumeAssignmentAction,
  getSelectedLanguageSelector,
} from '../../student/Assignments/ducks'
import { redirectToStudentPage } from '../../publicTest/utils'
import TestInfoModal from '../../publicTest/TestInfoModal'
import { setSelectedLanguageAction } from '../../student/sharedDucks/AssignmentModule/ducks'
import {
  getUserAccommodations,
  getUserFeatures,
} from '../../student/Login/ducks'
import RequirePassword from '../../assessment/RequirePassword'

const { STUDENT, TEACHER, DISTRICT_ADMIN, SCHOOL_ADMIN } = roleuser

const AssignmentEmbedLink = ({
  user = {},
  match,
  fetchAssignmentsByTestId,
  fetchAssignmentsForStudent,
  loadingAssignments,
  assignments,
  startAssignment,
  resumeAssignment,
  history,
  isVersionId,
  languagePreference,
  setSelectedLanguage,
  accommodations,
  passwordModalVisible,
  isPasswordValidated,
  userFeatures,
}) => {
  const { testId, versionId } = match.params
  const [showTestInfoModal, setShowTestInfoModal] = useState(false)
  const [testInfoModalProps, setTestInfoModalProps] = useState(null)
  useEffect(() => {
    ;(async () => {
      const { role } = user
      if ([TEACHER, DISTRICT_ADMIN, SCHOOL_ADMIN].includes(role)) {
        fetchAssignmentsByTestId(testId)
      } else if (role === STUDENT) {
        if (isVersionId && versionId) {
          try {
            fetchAssignmentsForStudent({ testId: versionId })
          } catch (err) {
            if (!err?.response) {
              Sentry.captureException(err)
            }
            history.push('/home/assignments')
            notfification({
              type: 'warning',
              msg: 'This assignment is not available.',
            })
          }
        } else {
          fetchAssignmentsForStudent({ testId })
        }
      }
    })()
  }, [])

  useEffect(() => {
    if (user?.role === STUDENT && loadingAssignments === false) {
      const result = redirectToStudentPage(
        assignments,
        history,
        startAssignment,
        resumeAssignment,
        {},
        languagePreference,
        setSelectedLanguage,
        accommodations,
        userFeatures,
        user?.role
      )

      if (result && result.shouldShowModal) {
        setTestInfoModalProps(result.modalProps)
        setShowTestInfoModal(true)
      }
    }
  }, [loadingAssignments])

  const canShowPasswordModal =
    user?.role === STUDENT &&
    loadingAssignments === false &&
    passwordModalVisible &&
    !isPasswordValidated

  return (
    <div>
      {canShowPasswordModal && <RequirePassword isStartAssignment />}
      {showTestInfoModal && testInfoModalProps && (
        <TestInfoModal
          {...testInfoModalProps}
          visible={showTestInfoModal}
          onCancel={() => setShowTestInfoModal(false)}
        />
      )}
      <Spin />
    </div>
  )
}

export default connect(
  (state) => ({
    user: getUser(state),
    loadingAssignments: get(state, 'publicTest.loadingAssignments'),
    assignments: getAllAssignmentsSelector(state),
    languagePreference: getSelectedLanguageSelector(state),
    accommodations: getUserAccommodations(state),
    isPasswordValidated: state.test.isPasswordValidated,
    passwordModalVisible: state.test.passwordModalVisible,
    userFeatures: getUserFeatures(state),
  }),
  {
    fetchAssignmentsByTestId: fetchAssignmentsByTestIdAction,
    fetchAssignmentsForStudent: fetchAssignmentsByTestAction,
    startAssignment: startAssignmentAction,
    resumeAssignment: resumeAssignmentAction,
    setSelectedLanguage: setSelectedLanguageAction,
  }
)(AssignmentEmbedLink)
